import { Outlet, Link, NavLink } from "react-router-dom";
import logo from '../assets/logo.svg';

const routes = [
  {
    path: '/syntax-highlighting',
    label: 'Syntax Highlighting'
  },
  {
    path: '/check-scss',
    label: 'Check Scss'
  },
  {
    path: '/api-cancelling',
    label: 'Api Cancelling'
  },
  {
    path: '/background-sync',
    label: 'Background Sync'
  },
  {
    path: '/css-styles',
    label: 'CSS Styles'
  },
  {
    path: '/css-in-js',
    label: 'CSS in JS'
  },
  {
    path: '/canvas',
    label: 'Canvas'
  },
  {
    path: '/check-less',
    label: 'Check LESS'
  },
  {
    path: '/check-sass',
    label: 'Check SASS'
  },
  {
    path: '/check-scss-replace',
    label: 'Check Scss'
  },
  {
    path: '/code-splitting',
    label: 'Code splitting'
  },
  {
    path: '/d3',
    label: 'D3'
  },
  {
    path: '/debounce-throttle',
    label: 'Debounce & Throttle'
  },
  {
    path: '/ether-js',
    label: 'Ether Js'
  },
  {
    path: '/glassmorphism',
    label: 'Glassmorphism'
  },
  {
    path: '/graphql',
    label: 'GraphQL'
  },
  {
    path: '/http2',
    label: 'HTTP 2'
  },
  {
    path: '/image-lazy-loading',
    label: 'Image lazy loading'
  },
  {
    path: '/indexed-db',
    label: 'Indexed DB'
  },
  {
    path: '/jwt-and-oauth',
    label: 'JWT & OAuth'
  },
  {
    path: '/js-profiler',
    label: 'Js profiler'
  },
  {
    path: '/markdown-editor',
    label: 'Markdown Editor'
  },
  {
    path: '/neomorphism',
    label: 'Neomorphism'
  },
  {
    path: '/network-throttling',
    label: 'Network throttling'
  },
  {
    path: '/pwa',
    label: 'PWA'
  },
  {
    path: '/promise-polyfills',
    label: 'Promise polyfills'
  },
  {
    path: '/react-profiler',
    label: 'React profiler'
  },
  {
    path: '/redux-async',
    label: 'Redux Async'
  },
  {
    path: '/svg',
    label: 'SVG'
  },
  {
    path: '/sentry',
    label: 'Sentry'
  },
  {
    path: '/socket-io',
    label: 'Socket.io'
  },
  {
    path: '/syntax-highlighting-replace',
    label: 'Syntax Highlighting'
  },
  {
    path: '/tailwind-css',
    label: 'Tailwind CSS'
  },
  {
    path: '/three-js',
    label: 'Three.js'
  },
  {
    path: '/treeshaking',
    label: 'Treeshaking'
  },
  {
    path: '/ws',
    label: 'WS'
  },
  {
    path: '/webgl',
    label: 'WebGL'
  },
  {
    path: '/webrtc',
    label: 'WebRTC'
  }
];

export default function Home() {
  const getLinkClass = ({ isActive }: { isActive: boolean }) => {
    return `main-nav-link ${isActive ? 'main-nav-link-active' : ''}`
  }
  console.log(routes);
  return (
    <div id="home-container">
      <Link id="logo-container" to="/">
        <img src={logo} alt="logo" id="logo" />
      </Link>
      <div id="app-route">
        <nav className="main-nav">
          {routes.map(({ path, label }) => (
            <NavLink
              to={path}
              className={getLinkClass}
              key={path}
            >
              {label}
            </NavLink>
          ))}
          <NavLink style={{ minHeight: 100 }} to="/"> </NavLink>
        </nav>
        <Outlet />
      </div>
    </div>
  );
}
